/**
 * Shared INSi identity-reliability status logic (labels, chip variants, and the
 * "status on save" rule). Pairs with `insiStatusColors` (colours) so the status
 * vocabulary lives in one place instead of being recomputed inline in the
 * create and edit dialogs.
 */

/** Status → i18n key for its French display label. */
export const INSI_STATUS_LABEL = {
  PROVISOIRE: 'Provisoire',
  RECUPEREE: 'Récupérée',
  QUALIFIEE: 'Qualifiée',
};

/** Status → `StatusChip` variant (reuses the generic status-chip palette). */
export const INSI_STATUS_CHIP_VARIANT = {
  PROVISOIRE: 'DRAFT',
  RECUPEREE: 'SCHEDULED',
  QUALIFIEE: 'ACTIVE',
};

/**
 * Resolve the reliability status a save will produce:
 *  - a confirmed re-search match → QUALIFIEE if an identity document was
 *    attested (one-shot), else RECUPEREE;
 *  - a provisional outcome (re-search abandoned) → PROVISOIRE;
 *  - otherwise the patient's already-stored status (unchanged).
 */
export const insiStatusOnSave = ({
  matched,
  provisional,
  attestationDocType,
  storedStatus,
} = {}) => {
  if (matched) return attestationDocType ? 'QUALIFIEE' : 'RECUPEREE';
  if (provisional) return 'PROVISOIRE';
  return storedStatus;
};
